import {
    HomeDemo1IcoPlatforms1,
    HomeDemo1IcoPlatforms2,
    HomeDemo1IcoPlatforms3,
    HomeDemo1IcoPlatforms4,
    HomeDemo1IcoPlatforms5,
    HomeDemo1IcoPlatforms6,

    HomeDemo1Services1,
    HomeDemo1Services2,
    HomeDemo1Services3,
    HomeDemo1Services4,
    HomeDemo1Services5,
    HomeDemo1Services6,

    HomeDemo1TokenIcon1,

    HomeDemo1TeamImg1,
    HomeDemo1TeamImg2,
    HomeDemo1TeamImg3,
    HomeDemo1TeamImg4,
    
    HomeDemo1Partners1,
    HomeDemo1Partners2,
    HomeDemo1Partners3,
    HomeDemo1Partners4,
    HomeDemo1Partners5,
    HomeDemo1Partners6,
    HomeDemo1Partners7,
    HomeDemo1Partners8,
    HomeDemo1Partners9,
    HomeDemo1Partners10,
    HomeDemo1Partners11,
    HomeDemo1Partners12,

    HomeDemo1BlogImg1,
    HomeDemo1BlogImg2,
    HomeDemo1BlogImg3

} from '../../utils/allImgs'

export const VerticalSocial = [
    {nameIco:'fa fa-telegram'},
    {nameIco:'fa fa-medium'},
    {nameIco:'fa fa-facebook'},
    {nameIco:'fa fa-twitter'},
    {nameIco:'fa fa-github'},
    {nameIco:'fa fa-instagram'},
    {nameIco:'fa fa-linkedin'}
]

export const SingleCoolFact = [
    {
        img:HomeDemo1IcoPlatforms1,
        ico_check:true
    },
    {
        img:HomeDemo1IcoPlatforms2,
        ico_check:false
    },
    {
        img:HomeDemo1IcoPlatforms3,
        ico_check:true
    },
    {
        img:HomeDemo1IcoPlatforms4,
        ico_check:true
    },
    {
        img:HomeDemo1IcoPlatforms5,
        ico_check:false
    },
    {
        img:HomeDemo1IcoPlatforms6,
        ico_check:true
    }
]

export const service_single_content = [
    {
        img:HomeDemo1Services1,
        title:'Smart Trading Modules'
    },
    {
        img:HomeDemo1Services2,
        title:'Adaptive Social Assistant'
    },
    {
        img:HomeDemo1Services3,
        title:'Analyzer of the News with powerful AII '
    },
    {
        img:HomeDemo1Services4,
        title:'Exchange Order Management'
    },
    {
        img:HomeDemo1Services5,
        title:'Module of Price Notification'
    },
    {
        img:HomeDemo1Services6,
        title:'Crypto Trading Platform'
    }

]

export const timelineInfo = [
    {
        timelineClass:"block block-left",
        title:'Platform Development Starts',
        date_from:'May 12, 2024',
        date_to:'Jun 19, 2024'
    },
    {
        timelineClass:"block block-right mt-30",
        title:'Groundwork Preparation for ICO',
        date_from:'Aug 18, 2024',
        date_to:'Sep 23, 2024'
    },
    {
        timelineClass:"block block-left mt-30",
        title:'Crypto Blockchain Release',
        date_from:'Oct 08, 2024',
        date_to:'Nov 16, 2024'
    },
    {
        timelineClass:"block block-right mt-30",
        title:'Release Bank & Cards Phase',
        date_from:'Dec 28, 2024',
        date_to:'Jan 29, 2019'
    }
]

export const ServiceBlock = [
    {
        classIco:"icon ti-mobile",
        title:"Powerfull Mobile and Online App"
    },
    {
        classIco:"icon ti-widget",
        title:"Brings more Transparency and Speed"
    },
    {
        classIco:"icon ti-settings",
        title:"Special for Multiple Use Capabilities"
    },
]

export const SocialListIco = [
    {icoName:"fa fa-facebook-square"},
    {icoName:"fa fa-twitter-square"},
    {icoName:"fa fa-github-square"},
    {icoName:"fa fa-instagram"},
    {icoName:"fa fa-medium"}
]

export const FQAInfo = [
    {
        text:'What are the objectives of this token?',
        ID:'Q1'
    },
    {
        text:'What is Token Sale and pre-sale?',
        ID:'Q2'
    },
    {
        text:'What is the pre-sale start date?',
        ID:'Q3'
    },
    {
        text:'how may I take part in pre-sale?',
        ID:'Q4'
    },
]

export const DocElementTitle = [
    {
        title:'WhitePaper'
    },
    {
        title:'OnePager'
    },
    {
        title:'Rating Review'
    },
    {
        title:'Marketing Plan'
    },
]

export const TokenText = [
    {
        text:'Lorem ipsum dolor sit amet, conse ctetur elit',
        img:HomeDemo1TokenIcon1
    },
    {
        text:'Sed quis accumsan nisi Ut ut felis',
        img:HomeDemo1TokenIcon1
    },
    {
        text:'felis congue nisl hendrerit commodo',
        img:HomeDemo1TokenIcon1
    },
    {
        text:'arch nemo sequi rem saepe ad quasi ullam.',
        img:HomeDemo1TokenIcon1
    },
]

export const MissionData = [
    {
        icoName:"ti-shine",
        title:"Quality"
    },
    {
        icoName:"ti-ruler-pencil",
        title:"Creativity"
    },
    {
        icoName:"ti-heart",
        title:"Reliability"
    },
]

export const TeamMember = [
    {
        img:HomeDemo1TeamImg1,
        title:'Sunny khan',
        text:'Executive Officer'
    },
    {
        img:HomeDemo1TeamImg2,
        title:'Ajoy Das',
        text:'Business Development'
    },
    {
        img:HomeDemo1TeamImg3,
        title:'Afroza Mou',
        text:'UX/UI Designer'
    },
    {
        img:HomeDemo1TeamImg4,
        title:'Lim Sarah',
        text:'Head of Marketing'
    },
    {
        img:HomeDemo1TeamImg1,
        title:'Sunny khan',
        text:'Executive Officer'
    },
    {
        img:HomeDemo1TeamImg2,
        title:'Ajoy Das',
        text:'Business Development'
    },
    {
        img:HomeDemo1TeamImg3,
        title:'Afroza Mou',
        text:'UX/UI Designer'
    },
    {
        img:HomeDemo1TeamImg4,
        title:'Lim Sarah',
        text:'Head of Marketing'
    },
]

export const PartnersData = [
    {img:HomeDemo1Partners1},
    {img:HomeDemo1Partners2},
    {img:HomeDemo1Partners3},
    {img:HomeDemo1Partners4},
    {img:HomeDemo1Partners5},
    {img:HomeDemo1Partners6},
    {img:HomeDemo1Partners7},
    {img:HomeDemo1Partners8},
    {img:HomeDemo1Partners9},
    {img:HomeDemo1Partners10},
    {img:HomeDemo1Partners11},
    {img:HomeDemo1Partners12}
]

export const BlogPost = [
    {img:HomeDemo1BlogImg1},
    {img:HomeDemo1BlogImg2},
    {img:HomeDemo1BlogImg3}
]
